import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { PAGE_URL } from '../../config/appConfig';
import popupImg from '../../assets/retail/retail-08.jpg';

const SEEN_KEY = 'omd_lead_popup_seen';

const LeadPopup = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // never on the quote page itself, and only once per browser session
    if (location.pathname === PAGE_URL.GET_QUOTE) return;
    let shown = false;
    try {
      shown = sessionStorage.getItem(SEEN_KEY) === '1';
    } catch (e) {}
    if (shown) return;

    const t = setTimeout(() => {
      setOpen(true);
      try {
        sessionStorage.setItem(SEEN_KEY, '1');
      } catch (e) {}
    }, 2500);
    return () => clearTimeout(t);
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  if (!open) return null;

  const close = () => setOpen(false);

  return (
    <div
      role='dialog'
      aria-modal='true'
      aria-label='Free design consultation offer'
      onClick={close}
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 99999,
        background: 'rgba(15, 22, 40, 0.62)',
        backdropFilter: 'blur(3px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '18px',
        animation: 'omdFade .25s ease',
      }}
    >
      <style>{`
        @keyframes omdFade{from{opacity:0}to{opacity:1}}
        @keyframes omdPop{from{opacity:0;transform:translateY(14px) scale(.97)}to{opacity:1;transform:none}}
      `}</style>

      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: '100%',
          maxWidth: '760px',
          background: '#fff',
          borderRadius: '20px',
          overflow: 'hidden',
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          boxShadow: '0 30px 80px rgba(0,0,0,.4)',
          fontFamily: "'Poppins', system-ui, sans-serif",
          animation: 'omdPop .3s ease',
          position: 'relative',
        }}
        className='omd-lead-modal'
      >
        <button
          onClick={close}
          aria-label='Close'
          style={{
            position: 'absolute',
            top: 12,
            right: 12,
            zIndex: 2,
            width: 36,
            height: 36,
            borderRadius: '50%',
            border: 'none',
            background: 'rgba(255,255,255,.9)',
            color: '#1f1a16',
            fontSize: 20,
            lineHeight: 1,
            cursor: 'pointer',
            boxShadow: '0 4px 12px rgba(0,0,0,.15)',
          }}
        >
          &times;
        </button>

        <div
          className='omd-lead-img'
          style={{
            background: `linear-gradient(180deg, rgba(20,37,76,.15), rgba(20,37,76,.35)), url(${popupImg}) center/cover no-repeat`,
            minHeight: '260px',
          }}
        />

        <div style={{ padding: '34px 32px' }}>
          <span
            style={{
              display: 'inline-block',
              fontSize: 11.5,
              letterSpacing: '.15em',
              textTransform: 'uppercase',
              fontWeight: 600,
              color: '#fff',
              background: 'linear-gradient(135deg,#F47A57,#e8623b)',
              padding: '7px 14px',
              borderRadius: 999,
            }}
          >
            Limited slots this month
          </span>

          <h2
            style={{
              fontSize: 26,
              fontWeight: 800,
              lineHeight: 1.12,
              letterSpacing: '-.5px',
              color: '#14254c',
              margin: '16px 0 10px',
            }}
          >
            Get a FREE design consultation &amp; quote
          </h2>

          <p style={{ fontSize: 14.5, color: '#6b6560', lineHeight: 1.6, margin: '0 0 20px' }}>
            Planning an interior, fit-out or retail space? Tell us about your project and
            our team will come back with a tailored quote — usually within one business
            day. No obligation.
          </p>

          <Link
            to={PAGE_URL.GET_QUOTE}
            onClick={close}
            style={{
              display: 'block',
              textAlign: 'center',
              fontWeight: 700,
              fontSize: 16,
              color: '#fff',
              background: 'linear-gradient(135deg,#F47A57,#e8623b)',
              borderRadius: 12,
              padding: '15px 20px',
              textDecoration: 'none',
              boxShadow: '0 12px 26px rgba(244,122,87,.34)',
            }}
          >
            Get My Free Quote →
          </Link>

          <button
            onClick={close}
            style={{
              display: 'block',
              width: '100%',
              marginTop: 12,
              background: 'none',
              border: 'none',
              color: '#8a97a1',
              fontSize: 13,
              cursor: 'pointer',
            }}
          >
            No thanks, maybe later
          </button>
        </div>
      </div>

      <style>{`
        @media (max-width: 620px){
          .omd-lead-modal{grid-template-columns:1fr !important;max-width:420px !important}
          .omd-lead-img{min-height:150px !important}
        }
      `}</style>
    </div>
  );
};

export default LeadPopup;
